var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('v-nav-tabs',{attrs:{"options":_vm.tabs}}):_c('v-mobile-tabs',{attrs:{"options":_vm.tabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }